import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/analytics', label: 'Executive', end: true },
  { to: '/analytics/finance', label: 'Finance' },
  { to: '/analytics/hr', label: 'HR' },
  { to: '/analytics/projects', label: 'Projects' },
  { to: '/analytics/qa', label: 'QA' },
  { to: '/analytics/reports', label: 'Report Builder' },
];

export default function AnalyticsShell() {
  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Analytics</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} end={n.end} className={({ isActive }) => isActive ? 'active' : ''}>{n.label}</NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main"><Outlet /></main>
      </div>
    </div>
  );
}
